import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';
import {isFirstLoad} from 'nutshell-core/utils/graphql-loading';

import type {
    GetProductsForLead as GetProductsForLeadQuery,
    GetProductsForLeadVariables as GetProductsForLeadVariables,
    GetProductsForLead_lead_products as Products,
} from 'nutshell-graphql-types';

import GET_PRODUCTS_FOR_LEAD from '../queries/get-products-for-lead.graphql';

export const useGetProductsForLead = (
    leadId: string
): {
    products: Products | null | undefined;
    isLoading: boolean;
    isFirstLoad: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch, networkStatus} = useQuery<
        GetProductsForLeadQuery,
        GetProductsForLeadVariables
    >(GET_PRODUCTS_FOR_LEAD, {
        variables: {
            leadId,
        },
        fetchPolicy: 'cache-and-network',
    });

    const isFirstLoading = isFirstLoad(networkStatus);

    return {
        products: data && data.lead && data.lead.products,
        isLoading: loading,
        isFirstLoad: isFirstLoading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
